<template>
  <modal
    title="Address"
    width="50"
    :showModal="showModal"
    @close-modal="closeModal"
  >
    <div>
      <GmapMap
        :center="center"
        :zoom="12"
        style="width:100%;  height: 400px;"
      />
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    center: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      //   center: { ...this.center },
    };
  },
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
  },
};
</script>

<style></style>
